import { ChevronLeft, ChevronRight } from "lucide-react";
import { Link } from "react-router";

export function directoryPageHref(basePath: string, page: number): string {
	return page <= 1 ? basePath : `${basePath}?page=${page}`;
}

export function DirectoryPagination({
	basePath,
	page,
	totalPages,
}: {
	basePath: string;
	page: number;
	totalPages: number;
}) {
	if (totalPages <= 1) return null;

	const disabledClassName = "btn btn-sm btn-secondary-soft pointer-events-none opacity-50";
	const linkClassName = "btn btn-sm btn-secondary-soft";

	return (
		<nav
			className="flex items-center justify-center gap-2 py-4"
			aria-label="Stránkování seznamu firem"
		>
			{page > 1 ? (
				<Link className={linkClassName} to={directoryPageHref(basePath, page - 1)}>
					<ChevronLeft className="h-4 w-4" />
					Předchozí
				</Link>
			) : (
				<span aria-disabled="true" className={disabledClassName}>
					<ChevronLeft className="h-4 w-4" />
					Předchozí
				</span>
			)}
			<span className="text-sm text-muted">
				Strana {page} z {totalPages}
			</span>
			{page < totalPages ? (
				<Link className={linkClassName} to={directoryPageHref(basePath, page + 1)}>
					Další
					<ChevronRight className="h-4 w-4" />
				</Link>
			) : (
				<span aria-disabled="true" className={disabledClassName}>
					Další
					<ChevronRight className="h-4 w-4" />
				</span>
			)}
		</nav>
	);
}
